import {Question} from "../../../../store/state/checklist-common";

export abstract class QuestionTypeTranslator {

	abstract getText(question: Question): string;

	hasExplanation(question: Question): boolean {
		return !!this.getExplanation(question);
	}

	getExplanation(question: Question): string | null {
		return null;
	}
}
